<template>
  <div class="container-fluid main-place mt-5 mb-3" >
    <div class="row">
      <div class="col-4">
        <img :src="avatarUrl" class="avatar"/>
      </div>
      <div class="col-8">
        Cześć {{ user }}<br/>
        <span></span>online<br/>
        {{ currentStoreName }}
      </div>
    </div>
  </div>
</template>
<script>
import userService from '@/service/userService'
import axios from 'axios'
import appConfig from '@/service/config'
import un from 'underscore'

export default {
  name: "MainPlace",
  data: () => ({
    storeName: "",
    user: ""
  }),
  computed: {
    currentStoreName: function() {
      return this.storeName;
    },
    avatarUrl: function() {
      return userService.getAvatarUrl()
    }
  },
  created() {
    this.loadCurrentStore();
    this.assignUser();
    this.refreshLoggedUser();
  },
  methods: {
    refreshLoggedUser: function () {
      userService.checkLoggedUser().then(res => {
        if (!res.data.validUser)
          this.$router.push({name: 'logout'});
        userService.saveUser(res.data);
        userService.saveCurrentStore(res.data.storeId)
        this.assignUser();
      })
      .catch(_ => {
        this.$router.push({name: 'logout'});
      })
    },
    assignUser: function () {
      const user = userService.getCurrentUser();
      this.user = user.userInfo.userName;
    },
    loadCurrentStore() {
      const req = axios({
        method: 'get',
        url: appConfig.baseUrl + '/stores/' + userService.getCurrentStore(),
        data: this.form,
        headers: {
          Authorization: userService.getAuthHeader()
        }
      })
      req.then(res => {
        this.storeName = res.data.name;
      }).catch(e => {
        // nie ma tagieog sklepu, nie możesz się zalogować
        this.$router.push({name: 'logout'})
      })
    }
  }
}
</script>
<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/place/MainPlace.vue